import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Star } from 'lucide-react';
export const Gallery = () => {
  const samples = [{
    id: 1,
    color: 'bg-white',
    rotation: '-rotate-2'
  }, {
    id: 2,
    color: 'bg-pink-100',
    rotation: 'rotate-3'
  }, {
    id: 3,
    color: 'bg-polkadot',
    rotation: '-rotate-1'
  }];
  return <section id="gallery" className="py-20 px-4 overflow-hidden" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <h2 className="text-4xl font-bold text-pink-900 mb-4" data-id="element-49">
            Cute Inspirations ✨
          </h2>
          <p className="text-pink-700 font-quicksand text-lg" data-id="element-50">
            See what others are creating with SnapMory.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 md:gap-12" data-id="element-51">
          {samples.map((sample, idx) => <motion.div key={sample.id} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} whileHover={{
          scale: 1.05,
          zIndex: 10
        }} className={`relative w-64 p-4 rounded-sm shadow-2xl ${sample.color} ${sample.rotation} transition-transform duration-300 cursor-pointer`} data-id="element-52">
              <div className="flex flex-col gap-3" data-id="element-53">
                {[1, 2, 3, 4].map(i => <div key={i} className="aspect-[4/3] bg-pink-200 rounded-sm overflow-hidden relative group" data-id="element-54">
                    <img src={`https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&q=80`} alt="Sample" className="w-full h-full object-cover mix-blend-multiply opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-55" />
                    <div className={`absolute inset-0 mix-blend-overlay opacity-40 ${idx === 0 ? 'bg-pink-400' : idx === 1 ? 'bg-orange-300' : 'bg-purple-300'}`} data-id="element-56"></div>
                  </div>)}
              </div>
              <div className="mt-4 text-center" data-id="element-57">
                <h3 className="font-pacifico text-xl text-pink-900" data-id="element-58">
                  SnapMory
                </h3>
              </div>

              {idx === 0 && <Heart className="absolute -top-4 -right-4 w-10 h-10 text-pink-500 fill-pink-500 rotate-12" data-id="element-59" />}
              {idx === 1 && <Sparkles className="absolute -bottom-4 -left-4 w-12 h-12 text-yellow-400 rotate-[-15deg]" data-id="element-60" />}
              {idx === 2 && <Star className="absolute top-1/2 -right-6 w-8 h-8 text-pink-400 fill-pink-400" data-id="element-61" />}
            </motion.div>)}
        </div>
      </div>
    </section>;
};